/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "/Users/pajk01/workspace/n34220_autoconfig_STATIC/vue-scrm_temp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.number.to-fixed.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Swiper from "vux/src/components/swiper/swiper.vue";
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex';
import wx from 'jweixin-1.2.0';
import MoreDiv from '@/components/MoreDiv';
import defaultImg from '@/resources/images/defalutClinic.png';
export default {
  props: {
    clinic: {
      type: Object
    },
    imgArray: {
      type: Array,
      "default": []
    },
    fromPage: {
      type: String
    }
  },
  data: function data() {
    return {
      imgIndex: 0,
      defaultImg: defaultImg,
      hasLocation: false,
      fullPath: ''
    };
  },
  components: {
    Swiper: Swiper,
    MoreDiv: MoreDiv
  },
  created: function created() {},
  computed: _objectSpread(_objectSpread({}, mapGetters({})), {}, {
    imgList: function imgList() {
      var imgArray = this.imgArray,
          imgList = [];
      var obj = {};

      if (imgArray.length == 0 && this.clinic) {
        imgList = [{
          url: 'javascript:',
          img: this.defaultImg
        }];
      } else if (imgArray.length > 0) {
        imgList = imgArray;
      }

      return imgList;
    },
    isChain: function isChain() {
      if (this.fromPage == 'chain') {
        return true;
      } else {
        return false;
      }
    },
    distance: function distance() {
      if (!this.clinic) {
        return false;
      }

      var distance = this.clinic.distance;

      if (distance) {
        distance = parseInt(distance);

        if (distance > 1000) {
          return (distance / 1000).toFixed(2) + 'km';
        } else {
          return distance + 'm';
        }
      } else {
        return false;
      }
    }
  }),
  mounted: function mounted() {},
  methods: _objectSpread(_objectSpread({}, mapActions({})), {}, {
    imgChange: function imgChange(index) {
      this.imgIndex = index;
    },
    //打电话
    callUp: function callUp() {
      var tel = this.clinic.mobile || this.clinic.phone || '';
      console.log('tel:  ' + tel);

      if (tel) {
        window.location.href = 'tel:' + tel;
      }
    },
    // 诊所地图
    toMapEvent: function toMapEvent() {
      this.$emit('toMapEvent', this.clinic);
    }
  })
};